import React from "react";
import { ComponentType } from "react";

import { Type } from "../../models";
import { getDeliveryTypes } from "../../selectors";

export interface InjectedTypesProps {
    types: Type[];
}

export const withTypes = <P extends InjectedTypesProps>(
    WrappedComponent: ComponentType<P>,
) => {
    return (props: Pick<P, Exclude<keyof P, keyof InjectedTypesProps>>) => (
        <WrappedComponent {...props as P} types={getDeliveryTypes(null)} />
    );
};
